import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserConfigResponse } from './models/user-config.response';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { UserConfigFactory } from './user-config.factory';
import { UserConfig } from './models/user-config.model';

@Injectable({
  providedIn: 'root',
})
export class UserConfigService {
  private readonly userConfigFactory = inject(UserConfigFactory);
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiService);
  private readonly userService = inject(UserService);

  getUserConfig(): Observable<UserConfig> {
    const apiUrl = `${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/config`;
    return this.http
      .get<UserConfigResponse>(apiUrl)
      .pipe(map((userConfigResponse) => this.userConfigFactory.buildUserConfig(userConfigResponse)));
  }
}
